import { mapDtoList, requireEnum } from './parse.js';

/**
 * Mirrors com.medprompt.generator.document.lmc.LmcContractViolationType
 */
export const LmcContractViolationType = Object.freeze({
  MISSED_APPOINTMENT: 'MISSED_APPOINTMENT',
  INAPPROPRIATE_PRESCRIBING: 'INAPPROPRIATE_PRESCRIBING',
  CHASING_HOSPITAL: 'CHASING_HOSPITAL',
  POST_OP_CHECK: 'POST_OP_CHECK',
  HOSPITAL_FIT_NOTE: 'HOSPITAL_FIT_NOTE',
  SICK_NOTE: 'SICK_NOTE',
  NON_CONTRACT_ADMIN: 'NON_CONTRACT_ADMIN',
  ONWARD_REFERRAL: 'ONWARD_REFERRAL',
  HOSPITAL_INVESTIGATION_REQUEST: 'HOSPITAL_INVESTIGATION_REQUEST',
  REFERRAL_REJECTION: 'REFERRAL_REJECTION',
  HOSPITAL_FOLLOW_UP: 'HOSPITAL_FOLLOW_UP',
});

/**
 * @param {unknown} raw
 * @param {string} typeName Owning type, for error messages
 * @returns {string[]}
 */
export function fromLmcContractViolationTypeList(raw, typeName) {
  return mapDtoList(raw, `${typeName}.lmcContractViolations`, (value) => (
    requireEnum(value, LmcContractViolationType, typeName, 'lmcContractViolations')
  ));
}
